import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import applyFormat from '../functions/applyFormat';
import validateInputArray from '../functions/validateInputArray';
import dynamicTransformation from '../functions/dynamicTransformation';
import dynamicValidation from '../functions/dynamicValidation';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const EditPerformanceBonusModal = () => {
    // get context from parent
    const {
        editPerformanceBonusModal, 
        setEditPerformanceBonusModal, 
        editPerformanceBonusRow, 
        masterCompanyData,
        getRefreshData,  
        snackbarAlert, 
        performanceBonusEditConfig, 
        performanceBonusLists
    } = useContext(PageContext);
    // initialize http context 
    const {
        POST, 
        PUT, 
    } = useContext(HttpContext);
    // initialize state
    const [values, setValues] = useState([]); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);
    const [statusChange, setStatusChange] = useState(false); 

    // event handler for values change 
    const onChange = () => {
        // determine if status has changed 
        if (values['active']['id'].toString() !== editPerformanceBonusRow['active'].toString()) {
            setStatusChange(statusChange => statusChange = true); 
        }
        else {
            setStatusChange(statusChange => statusChange = false); 
        } 
    }

    // event handler for submit button click
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            if (!statusChange) {
                let requestValues = [{...values}]; 
                // validate input
                let checkError = validateInputArray(
                    requestValues, 
                    performanceBonusEditConfig,
                    dynamicValidation,
                    performanceBonusLists, 
                    snackbarAlert,  
                    error, 
                    setError, 
                    dynamicTransformation, 
                    {}
                ); 
                // exit request if error 
                if (checkError) {
                    reject(); 
                    return; 
                }
                // add mastercompanyid to request body 
                requestValues[0]['mastercompanyid'] = masterCompanyData['mastercompanyid'];
                // get oldValues to attach to request 
                let temp = {...editPerformanceBonusRow}
                let oldValues = applyFormat(temp, performanceBonusEditConfig, performanceBonusLists, null); 
                oldValues = dynamicTransformation(oldValues, performanceBonusEditConfig, {}); 
                // make post request 
                let response; 
                PUT('/client/performanceBonus', {
                    ...requestValues[0], 
                    oldValues: oldValues
                }).then(res => {
                    console.log(res);
                    response = res; 
                    // hide modal on success
                    setEditPerformanceBonusModal(editPerformanceBonusModal => editPerformanceBonusModal = false);
                    // trigger success alert
                    snackbarAlert(true, 'Successfully uploaded data.', 'success');
                    // refresh CompanyDetailsPage using function from parent
                    return getRefreshData();
                }).then(res => {
                    console.log(res); 
                    // resolve on success
                    resolve(response); 
                }).catch(err => {
                    console.log(err);
                    // show alert on error
                    snackbarAlert(true, 'Error uploading data.', 'error');
                    // reject on error
                    reject(err); 
                });
            }
            else {
                // validate status input 
                if (!performanceBonusLists['active'].includes(values['active'])){
                    // show snackbar on failure
                    snackbarAlert(true, 'Invalid status input.', 'error'); 
                    reject(); 
                    return; 
                }
                // make PUT request 
                let response; 
                PUT('/client/incentiveSetupStatus', {
                    active: values['active']['id'], 
                    incentivesetupid: values['incentivesetupid'], 
                    mastercompanyid: masterCompanyData['mastercompanyid'], 
                    companyid: values['companyid'], 
                    oldValues: {
                        active: editPerformanceBonusRow['active']
                    }
                }).then(res => {
                    console.log(res);
                    response = res;
                    // hide modal on success
                    setEditPerformanceBonusModal(editPerformanceBonusModal => editPerformanceBonusModal = false);
                    // trigger success alert
                    snackbarAlert(true, 'Successfully uploaded data.', 'success');
                    // refresh CompanyDetailsPage using function from parent
                    return getRefreshData();
                }).then(res => {
                    console.log(res); 
                    // resolve on success
                    resolve(response); 
                }).catch(err => {
                    console.log(err);
                    // show alert on error
                    snackbarAlert(true, 'Error uploading data.', 'error');
                    // reject on error
                    reject(err); 
                });
            }
        });         
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (performanceBonusEditConfig){
            setConfig(config => config = performanceBonusEditConfig); 
        }
    }, [performanceBonusEditConfig]); 

    // useEffect to run on editPerformanceBonusRow change
    useEffect(() => {
        if (editPerformanceBonusRow) {
            // add ids to lookup values 
            let temp = {
                ...editPerformanceBonusRow // destructure to pass by value 
            }; 
            temp = applyFormat(temp, performanceBonusEditConfig, performanceBonusLists, null); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [editPerformanceBonusRow]); 

    return(
        <> 
            <CCOffcanvas
                title = { `Edit Setup ID: ${editPerformanceBonusRow['incentivesetupid']}`}
                onCanvasClose={()=>setEditPerformanceBonusModal(editPerformanceBonusModal => editPerformanceBonusModal = false)}
                show={editPerformanceBonusModal}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {/* map DynamicPageInput over all elements of input config */}
                        {config.map((el) => 
                            el['edit'] == true &&
                            (!statusChange || el['columnid'] == 'active') ? 
                            <>
                                <div>
                                    <DynamicPageInput 
                                        data={values} 
                                        setData={setValues} 
                                        config={el} 
                                        args={performanceBonusLists} 
                                        width={'100%'} 
                                        onChangeFunction={onChange} 
                                        showError={error[0][el['columnid']]}
                                        topAlignTypography={true}
                                    />
                                </div>
                            </>
                            : <></>
                        )}
                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        {/* button to submit edits to rebate setup */}
                        <ButtonComponent tag={"Cancel"} 
                                border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                                onButtonClick={()=>setEditPerformanceBonusModal(editPerformanceBonusModal => editPerformanceBonusModal = false)}
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditPerformanceBonusModal; 